import { getStorageData, saveStorageData } from 'app/utils/localStorage/localStorage';
import { debounce } from 'app/utils/helpers';
import { getCurrentStoreData } from 'app/utils/globalDataHelpers';
import './cookie-banner.scss';

const COOKIE_TITLE = 'CookiesAccepted';
const showCookieMessage = !getStorageData(COOKIE_TITLE);

const checkCookieOnLoad = cookieName => {
  const cookieBanner = document.querySelector('.cookie-banner');
  const cookieBannerCTA = document.querySelector('.cookie-banner__cta-link');
  const footer = document.querySelector('.footer');

  cookieBanner.classList.add('display-block');
  cookieBannerCTA.addEventListener('click', e => {
    e.preventDefault();
    cookieBanner.classList.remove('display-block');
    footer.style.marginBottom = 0;
  });

  footer.style.marginBottom = `${cookieBanner.offsetHeight}px`;
  const debounceTime = 10;
  window.addEventListener(
    'resize',
    debounce(
      () => {
        footer.style.marginBottom = `${cookieBanner.offsetHeight}px`;
      },
      debounceTime,
      true
    )
  );

  saveStorageData(cookieName, 'true');
};

async function initCookieBanner() {
  const { cookiePolicyOverlayEnabled } = await getCurrentStoreData();
  if (cookiePolicyOverlayEnabled) {
    checkCookieOnLoad(COOKIE_TITLE);
  }
}

if (showCookieMessage) {
  initCookieBanner();
}
